import styled, { css } from 'react-emotion';
import theme from '@lyearn-team/theme-config';

export const LoginTypesWrapper = styled.div`
  ${({ flexDirection }) => `
    display: flex;
    flex-direction: ${flexDirection};
    width: 100%;
    justify-content: center;
    @media (max-width: 767px) {
      flex-direction: column;
    }
  `}
`;

export const SocialButtonWrapper = styled.div`
  ${({ marginLeftAuto }) => `
    .signInWithSprinklr {
      font-size: 16px;
      line-height: 20px;
      color: #606c7a;
      padding: 0 15px;
      height: 50px;
      border-radius: 2px;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;
      background: #4285f4;
      box-shadow: 0 1px 4px 0 rgba(216, 224, 230, 0.5);
      -webkit-box-shadow: 0 1px 4px 0 rgba(216, 224, 230, 0.5);
      -moz-box-shadow: 0 1px 4px 0 rgba(216, 224, 230, 0.5);
      cursor: pointer;
      transition: all 0.15s linear;
      -webkit-transition: all 0.15s linear;
      margin-bottom: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 24px;
        height: 24px;
        margin-right: 9px;
      }
    }
    .signInWithOkta {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.5px;
      height: 36px;
      width: 185px;
      color: ${theme.color.dark.white};
      display: flex;
      align-items: center;
    }
    .signInWithGoogleButton {
      font-family: Roboto, sans-serif;
      font-size: 14px;
      background-color: #4285f4;
      letter-spacing: 0.22px;
      border-radius: 2px;
      width: 185px;
      height: 36px;
      cursor: pointer;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12);
      color: white;
      display: flex;
      align-items: center;
      @media (min-width: 767px) {
        margin-right: 24px;
      }
      ${marginLeftAuto ? 'margin-left: auto' : ''}
      @media (max-width: 767px) {
        margin-bottom: 20px;
        width: 100%;
      }
    }
    .google-button-text {
      width: 100%;
      font-weight: 600;
      text-align: center;
    }
    .google-logo {
      background: white;
      width: 36px;
      height: 36px;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
    }
    .signInWithSprinklr:hover,
    .signInWithOkta:hover {
      background: #0274b3;
      color: white;
      svg,
      svg * {
        fill: white;
      }
    }
  `}
`;

export const signInWithSAML = marginLeftAuto => {
  return css`
    width: 100%;
    height: 36px;
    ${marginLeftAuto ? 'margin-left: auto' : ''}
    @media (max-width: 767px) {
      margin-bottom: 20px;
      width: 100%;
    }
  `;
};
